<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
    },
    groupClasses: {
      type: String
    },
    config: {
      required: true
    }
  },
}
</script>

<template>
  <div class="table-responsive" :class="groupClasses">
    <table
        v-bind="$attrs"
        :id="id"
        ref="table"
        class="table table-sm table-hover table-striped"
        :data-config="config"
    ></table>
  </div>
</template>